module.exports = __webpack_public_path__ + "static/media/icon-calendar-warning.e6f1538d.svg";